import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DrumSettings } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import SelectionComponent from './SelectionComponent';

export interface DrumSetProps {}

const DrumSet: React.FC<DrumSetProps> = () => {
  const { t } = useTranslation();
  const next = useNextStepAfterUpdate();
  const { settings } = React.useContext(TranscriptionDialogContext);

  const handleClick = (drum_notes: Partial<DrumSettings['drum_notes']>) => {
    next(
      {
        drum_notes,
      },
      settings.instruments[0]
    );
  };

  const answers = [
    {
      title: t('home.input.dialog.drumset.all'),
      key: 'all',
    },
    {
      title: t('home.input.dialog.drumset.standard'),
      key: 'standard',
    },
    {
      title: t('home.input.dialog.drumset.simple'),
      key: 'simple',
    },
  ];
  return <SelectionComponent answers={answers} handleClick={handleClick} id="drumset" />;
};

export default DrumSet;
